import { toast } from "react-toastify";
import { MapConstants, MarkerConstants } from "../_constants";
import { MapService } from "../_services";

export const MapActions = {
  getMapsByChronicle,
  getMapsByWorld,
  getMapById,
  updateMap,
  createNewMap,
  deleteMapById,
};

function getMapsByChronicle(chronicleID) {
  return (dispatch) => {
    dispatch(request(chronicleID));

    return MapService.getChronicleMaps(chronicleID).then(
      (maps) => {
        dispatch(success(maps));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Retrieve Maps (Chronicle): `, message);
        toast.error("Unable to retrieve Maps.");
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MapConstants.FETCH_MAPS_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MapConstants.FETCH_MAPS_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MapConstants.FETCH_MAPS_FAILURE,
      error,
    };
  }
}

function getMapsByWorld(worldID) {
  return (dispatch) => {
    dispatch(request(worldID));

    return MapService.getWorldMaps(worldID).then(
      (maps) => {
        dispatch(success(maps));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Retrieve Maps (World): `, message);
        toast.error("Unable to retrieve Maps.");
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MapConstants.FETCH_WORLD_MAPS_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MapConstants.FETCH_WORLD_MAPS_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MapConstants.FETCH_WORLD_MAPS_FAILURE,
      error,
    };
  }
}

function getMapById(mapID) {
  return (dispatch) => {
    dispatch(request(mapID));

    return MapService.getMap(mapID).then(
      (map) => {
        dispatch(success(map));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Get Map: `, message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MapConstants.FETCH_MAP_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MapConstants.FETCH_MAP_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MapConstants.FETCH_MAP_FAILURE,
      error,
    };
  }
}

function createNewMap(mapData) {
  return (dispatch) => {
    dispatch(request(mapData));

    return MapService.createMap(mapData).then(
      (map) => {
        toast.success(`Map "${map.title}" created successfully!`);
        dispatch(success(map));
        return map;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Create Map: `, message);
        toast.error(`Unable to create new Map "${mapData.title}".`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MapConstants.CREATE_MAP_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MapConstants.CREATE_MAP_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MapConstants.CREATE_MAP_FAILURE,
      error,
    };
  }
}

function updateMap(mapID, mapData) {
  return (dispatch) => {
    dispatch(request({ mapID, mapData }));

    return MapService.updateMap(mapID, mapData).then(
      (map) => {
        toast.success(`Map "${map.title}" updated successfully!`);
        dispatch(success(map));
        return map;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Update Map: `, message);
        toast.error(`Unable to update Map "${mapData.title}".`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MapConstants.EDIT_MAP_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MapConstants.EDIT_MAP_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MapConstants.EDIT_MAP_FAILURE,
      error,
    };
  }
}

function deleteMapById(mapID) {
  return (dispatch) => {
    dispatch(request(mapID));

    return MapService.deleteMap(mapID).then(
      (result) => {
        console.log("MAP DELETE ACTION", result);
        toast.success("Map deleted successfully!");
        dispatch(success(mapID));
        // dispatch(refreshMarkers(mapID));
        dispatch(refresh(result));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Delete Map: `, message);
        toast.error("Unable to delete Map.");
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: MapConstants.DELETE_MAP_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: MapConstants.DELETE_MAP_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: MapConstants.DELETE_MAP_FAILURE,
      error,
    };
  }

  function refresh(payload) {
    return {
      type: MapConstants.REFRESH_EVENTS_AND_MARKERS,
      payload,
    };
  }
}
